// Product-page Accordion Start
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.product__accordion--col .accordion__inner');

  accordionItems.forEach(item => {
    const button = item.querySelector('.product__accordion--col .accordion__label');
    const content = item.querySelector('.product__accordion--col .accordion__content');

    // Set initial height for open content
    if (item.getAttribute('data-open') === 'true') {
      content.style.height = content.scrollHeight + 'px';
    }

    button.addEventListener('click', () => {
      const isOpen = item.getAttribute('data-open') === 'true';

      // Close all accordion items
      accordionItems.forEach(innerItem => {
        innerItem.setAttribute('data-open', 'false');
        innerItem.querySelector('.product__accordion--col .accordion__label').setAttribute('aria-expanded', 'false');
        const innerContent = innerItem.querySelector('.product__accordion--col .accordion__content');
        innerContent.style.height = '0';
        setTimeout(() => {
          innerContent.style.display = 'none';
        }, 300); // Match the transition duration
      });

      // Open the clicked accordion item
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        button.setAttribute('aria-expanded', 'true');
        content.style.display = 'block';
        setTimeout(() => {
          content.style.height = content.scrollHeight + 'px';
        }, 10); // Small delay to allow display change to take effect
      }
    });
  });

  document.querySelectorAll("video").forEach(el => {
    el.closest(".accordion__inner").querySelector("button.accordion__label").addEventListener("click", function(e) {
      const video = e.currentTarget.closest(".accordion__inner").querySelector("video");
      setTimeout(function(){
        if(video.closest(".accordion__content").style.display == "block"){
          video.play();
        }
        else{
          video.pause();
        }
      }, 300)
    });
  });
});
// Product-page Accordion End
  
// Video popup start
document.addEventListener('DOMContentLoaded', function() {
  var vimeoPlayer, youtubePlayer;

  if (document.querySelector('#vimeo_video')) {
    var vimeoIframe = document.querySelector('#vimeo_video');
    vimeoPlayer = new Vimeo.Player(vimeoIframe);
  }

  window.onYouTubeIframeAPIReady = function() {
    if (document.querySelector('#youtube_video')) {
      youtubePlayer = new YT.Player('youtube_video');
    }
  };

  function togglePopupVisibility(popup) {
    popup.classList.toggle('hide');
    document.body.classList.toggle('overflow', !popup.classList.contains('hide'));
    if (popup.classList.contains('hide')) {
      if (vimeoPlayer) vimeoPlayer.pause();
      if (youtubePlayer) youtubePlayer.pauseVideo();
    } else {
      if (vimeoPlayer) vimeoPlayer.play();
      if (youtubePlayer) youtubePlayer.playVideo();
    }
  }

  document.querySelectorAll('.video-toggle').forEach(function(element) {
    element.addEventListener('click', function(event) {
      event.preventDefault();
      var target = event.target.closest('.video-toggle').getAttribute('data-video-target');
      var popup = document.getElementById(target);
      if (popup) {
        togglePopupVisibility(popup);
      }
    });
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('.video--box__iframe') && !event.target.closest('.video-toggle')) {
      var popups = document.querySelectorAll('.video__popup');
      popups.forEach(function(popup) {
        if (!popup.classList.contains('hide')) {
          popup.classList.add('hide');
          document.body.classList.remove('overflow');
          if (vimeoPlayer) vimeoPlayer.pause();
          if (youtubePlayer) youtubePlayer.pauseVideo();
        }
      });
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      var popups = document.querySelectorAll('.video__popup');
      popups.forEach(function(popup) {
        if (!popup.classList.contains('hide')) {
          popup.classList.add('hide');
          document.body.classList.remove('overflow');
          if (vimeoPlayer) vimeoPlayer.pause();
          if (youtubePlayer) youtubePlayer.pauseVideo();
        }
      });
    }
  });
});
// Video popup end